<template>
    <label :class="['checkbox-container', {disabled}, {'color-battleship-gray': !error}, {'color-alert': error}, {'label-left' : labelLeft}]"><span :class="['label-text', {disabled}, labelClass, {selected: checked}]" v-html="label"></span>
        <input type="checkbox" @click="onToggle" :checked="checked" :disabled="disabled">
        <span :class="['checkmark',  {'radio': radio}]"></span>
    </label>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from 'vue-property-decorator';

@Component
export default class Checkbox extends Vue
{
    @Prop(String) readonly label!: string;
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({type: Boolean, default: false}) readonly error!: boolean;
    @Prop({type: Boolean, default: false}) readonly radio!: boolean;
    @Prop({type: Boolean, default: false}) readonly checked!: boolean;
    @Prop({type: Boolean, default: false}) readonly labelLeft!: boolean;
    @Prop(String) readonly labelClass!: string;

    @Emit('change')
    onToggle($event: Event) {
        const isChecked = (<HTMLInputElement>$event.target).checked;
        if (this.radio) {
            if (this.checked) {
                $event.preventDefault();
            }
        }
        return isChecked;
    }
}
</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

// custom checkbox
.checkbox-container {
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 23px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 1em;

    &.disabled {
        .checkmark {
            border: 2px solid var(--light-gray);
        }
    }

    &.color-alert {
        .checkbox-link {
            color: var(--alert) !important;
        }
    }

    &.label-left {
        padding-left: 0px;
        .checkmark {
            left: auto;
            right: 0;
        }
    }
}
.checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}
.checkmark {
    position: absolute;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: var(--white);
    border: 2px solid var(--gray);
    border-radius: 2px;

    &.radio {
        border-radius: 50%;
    }
}
.checkbox-container input:checked ~ .checkmark {
    border-color: var(--primary);
    background-color: var(--primary);
}
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}
.checkbox-container input:checked ~ .checkmark:after {
    display: block;
}
.checkbox-container .checkmark:after {
    left: 5px;
    top: 0px;
    width: 7px;
    height: 13px;
    border: solid var(--white);
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

.label-text {
    display: inline-block;

    &.selected {
        font-weight: 600;
        color: var(--black);
    }
}
</style>
